import React from 'react';
import { PropTypes } from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Text,
} from '@knockrentals/knock-shared-web';

const useStyles = makeStyles({
  textWordBreak: {
    wordBreak: 'break-word',
  },
});

const ConfirmationDialog = ({
  closeDialog,
  handleConfirmation,
  isOpen,
  message,
  primaryButtonClass,
  primaryButtonText,
  secondaryButtonAction,
  secondaryButtonText = 'Cancel',
  title,
  transitionDuration,
}) => {
  const classes = useStyles();

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      onClose={closeDialog}
      open={isOpen}
      transitionDuration={transitionDuration}
    >
      <DialogTitle disableTypography className={classes.textWordBreak}>
        <Text variant="subtitle1">{title}</Text>
      </DialogTitle>

      <DialogContent>
        <DialogContentText className={classes.textWordBreak}>
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={secondaryButtonAction || closeDialog}
          variant="outlined"
        >
          {secondaryButtonText}
        </Button>

        <Button
          className={primaryButtonClass}
          color="primary"
          onClick={handleConfirmation}
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmationDialog.propTypes = {
  closeDialog: PropTypes.func,
  handleConfirmation: PropTypes.func,
  isOpen: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  primaryButtonClass: PropTypes.string,
  primaryButtonText: PropTypes.string,
  secondaryButtonAction: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  title: PropTypes.string,
  transitionDuration: PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number,
  }),
};

export default ConfirmationDialog;
